<template>
    <div>
      <div id="detailtop" style="padding-top: 90px;" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">
        <div style="margin: 5px;">
          <!-- 广告 -->
          <el-row :gutter="0">
    
            <el-col :xs="12*item.span" :sm="6*item.span" :md="6*item.span" :lg="4*item.span" v-for="(item,index) in PageData.indexadlist" :key="index"><!-- style="margin-bottom: -10px" -->

              <a :href="item.url" target="_blank">
                <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="item.image" fit="cover" >
                  <template #error>
                    <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                  </template>
                </el-image>
              </a>
    
            </el-col>
    
          </el-row>
        </div>
    
    
        <div class="size-body">
    
          <div>

            <el-row :span="24" justify="center">
              <el-col class="video-box" :xs="24" :sm="24" :md="16" :lg="16" :xl="16" style=" aspect-ratio: 16/9;background-color: #000;">


                <div id="adMask" class="ad-mask">
                  <div id="adclose" class="ad-close"></div>
                  <div id="adclose2" class="ad-close2"></div>
                  <a :href="ad_Show.url" target="_blank"><img width="100%" :src="ad_Show.image" :alt="ad_Show.title"></a>
                </div>

                <!-- [player] -->
                <!-- <video :poster="PageData.image==''?'@/assets/video_bg.gif':PageData.image" class="video" ref="video" controls style="width: 100%;height: 100%;"></video> -->
                <!-- <video id="videoPlayer" class="video" ref="video" controls style="width: 100%;height: 100%;"></video> -->
                <div id="video_div" style="width: 100%;height: 100%;"></div>

              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="padding: 15px;">

                <div style="font-size: 25px;font-weight: bold;padding-bottom: 30px;">{{ PageData.title }}</div>
                <div class="video_info">감독: 

                  <span>{{ PageData.director }}</span>

                </div>
                <div class="video_info">출연: 

                  <span>{{ PageData.star }}</span>

                </div>
                <div class="video_info">회차: 

                  <span v-if="PageData.ending=='0'">
                    완결<!-- 已完结 -->
                  </span>
                  <span v-else>
                    {{ PageData.ending.length>4?PageData.ending:'제 '+PageData.ending+' 화' }} 
                  </span>

                </div>

                <div style="font-size: 16px;font-weight: bold;padding-bottom: 15px;">내용소개
                  <div style="color:#fff;padding-left: 15px;font-weight: normal;font-size: 14px;line-height: 30px;">
                    <span style="display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;overflow: hidden;font-size: 12px;">{{ PageData.intor }}</span>
                  </div>
                </div>
                
              </el-col>
            </el-row>
            
          </div>



          <div class="playList font_Arial" style="width: 100%;text-align: left;">
            <div style="display: inline-block;padding: 3px 3PX;" v-for="(item,index) in PageData.play1.slice().reverse()" :key="index">
              <div @click="play(1,PageData.play1.length-item.num)" :class="l==1&&g==PageData.play1.length-item.num?'item-select':'item'" style="">{{ item.tit }}</div>
            </div>
          </div>



          <div>
            <!-- 推荐视频 -->
            <div class="title-s">
              연관영상
            </div>

            <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
              <el-col :xs="12" :sm="6" :lg="3" class="card" style="position: relative;" v-for="(item,index) in PageData.top" :key="index" >
                
                <!-- <span v-if="item.ending==0" class="ending">완결</span>
                <span v-else class="ending">제 {{ item.ending }} 화</span> -->
                <span v-if="item.today==1" class="ending">Today</span>
                
                <router-link :to="'/Detail?id='+item.id">

                  <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                      style="margin: 3px 3px;border: 0;border-radius: 5px;background-color: #000;">
                      <span>
                      <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px 5px 0 0;text-align: center;" :src="item.image" fit="cover">
                          <div slot="error">
                          <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                          <div slot="placeholder">
                          <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                              fit="cover">
                          </div>
                      </el-image>
                      </span>
                      

                      <div style="margin: 0 8px;padding: 3px 0;min-height: 40px;">
                      <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                          <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                          <div>{{ item.title }}</div>
                          <div>
                            <!-- {{ item.star }} -->
                            <span v-if="item.ending==0">완결</span>
                            <span v-else>제 {{ item.ending }} 화</span>
                          </div>
                          </div>
                      </el-tooltip>
                      </div>

                  </el-card>

                </router-link>

              </el-col>
            </el-row>
          </div>
    
          
    
          
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  //广告用
  var countdown = 10;
  var counter
  var player = null

  import Hls from 'hls.js'
  import '../assets/js/PlayerButton';
  export default {
    name: 'DetailView',
    components: {
  
    },
    data(){
      return{
        loading:true,
        showMoreList:null,
        id:'',
        l:1,//哪条线路
        g:1,//当前第几集
        PageData:{
          title:'loading',
          ending:0,
          start:'loading',
          director:'loading',
          image:'',
          intor:'loading',
          play1:[],
          top:[]
        },
        ad_Show:{title:'',url:'',image:''},
        subtitleCues:[],
        currentSubtitle:'',
        subtitleTrack:null,
        subtitleTrackUrl:'',
        subtitleRequestId:0,
        subtitleTimer:null
      }
    },
    mounted(e) {
      this.id = this.$route.query.id
      var this_ = this

      this.video_obj()
      this_.loadPage(this_.id)

      // setTimeout(function() {
      //   this_.loadPage(this_.id)
      //   console.log("*********")
      // },1000)
      

      // var element = document.getElementById('detailtop');
      //     element.scrollIntoView({ behavior: "smooth" });

    },
    beforeDestroy() {
      this.clearSubtitle()
      clearInterval(this.subtitleTimer)
      this.subtitleTimer = null
      try {
        if(player){
          player.dispose()
          player = null
        }
      } catch (error) {

      }
    },
    watch: {
      // 监听路由对象 $route 的变化
      '$route': {
        handler: function (to, from) {
          // 路由变化时执行的操作

          this.loading = true
        
          // var element = document.getElementById('detailtop');
          // element.scrollIntoView({ behavior: "smooth" });

          if(this.id !== this.$route.query.id){
            this.id = this.$route.query.id
            
            
            
            // if(player!==null){
            //   player.dispose()
            //   player = null
            //   console.log("销毁") 
            // }
            
            // video_obj()
            this.loadPage(this.id)
          }

          

        },
        // 设置为深度监听
        deep: true
      }
    },
    methods: {
      video_obj(){
        var this_ = this
        
        // if(TT == 0){
          // this.$nextTick(function(){

          try {
            if(player){
              player.dispose()
            }
          } catch (error) {

          }

          document.getElementById('video_div').innerHTML = '<video id="videoPlayer" class="video" ref="video" controls crossorigin="anonymous" style="width: 100%;height: 100%;"></video>'

          player = TCPlayer("videoPlayer",{
            sources: [],
            // sources: [{
            //   src: "", 
            //   // type: "application/x-mpegURL",
            //   type: "video/mp4",
            // }],
            // m3u8:this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url,
            // URL:this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url,
            // sources: [{
            //   src: "https://play.xluuss.com/play/YaO6YMNe/index.m3u8",
            //   // type: "application/x-mpegURL",
            //   type: "video/mp4",
            // }],
            language: 'ko',
            // preload: "auto",
            playbackRates: [],
            // poster:this_.PageData.image==''?'@/assets/video_bg.gif':this_.PageData.image,
            // autoplay:true,
            bigPlayButton:true,
            licenseUrl: 'license/url',
          })

          player.controlBar.addChild('NewButton1', {}, 2); 
          player.controlBar.addChild('NewButton2', {}, 3);

          // })
        // }

        

        

        // this.loadPage(this.id)

        
      },
      loadPage(id){
        var this_ = this

        // console.log(this.baseURL + "detail?id="+id)

        this.httpinfo.GetInfo(this,this.baseURL + "detail?mark="+this.baseMark+"&top=8&id="+id, function(e) {
          if(e.data.code==0){

            this_.PageData = e.data.data.detail

            let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
            this_.PageData.indexadlist.forEach(function(item){
                if(item.rand=='0'){
                Temp_Rand_Arr.push(item)
                }else{
                Temp_No_Rand_Arr.push(item)
                }
            })
            Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
            this_.PageData.indexadlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组


            //返转
            // this_.PageData.play1.reverse()


            // 播放
            document.title = this_.PageData.title;
            //如果传来第几集为0 那么就播放最新的一个
            this_.g = (this_.g==0?(this_.PageData['play'+this_.l].length):this_.g)
            if(this_.g>this_.PageData['play'+this_.l].length){
              this_.g = this_.PageData['play'+this_.l].length
            }    
            
            

            // this_.play(this_.l,this_.g)
            
            // 视频覆盖广告
            if(this_.PageData.adlist1.length>0){
              let min = 0,max = this_.PageData.adlist1.length - 1,num = 0

              num = Math.floor(Math.random() * (max - min) + min)

              this_.ad_Show.title= this_.PageData.adlist1[num].title
              this_.ad_Show.url= this_.PageData.adlist1[num].url
              this_.ad_Show.image= this_.PageData.adlist1[num].image

              this_.ad_Time()
            }
            // 视频覆盖广告

            // document.getElementById('video_div').innerHTML = '<video id="videoPlayer" class="video" ref="video" controls style="width: 100%;height: 100%;"></video>'
            setTimeout(function() {
              
              // console.log(this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url)

              // let video_url = this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url

              this_.play(this_.l,this_.g)

              // player = TCPlayer("videoPlayer",{
              //   sources: [{
              //     src: this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url, 
              //     // type: "application/x-mpegURL",
              //     type: "video/mp4",
              //   }],
              //   // m3u8:this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url,
              //   // URL:this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url,
              //   // sources: [{
              //   //   src: "https://play.xluuss.com/play/YaO6YMNe/index.m3u8",
              //   //   // type: "application/x-mpegURL",
              //   //   type: "video/mp4",
              //   // }],
              //   language: 'ko',
              //   // preload: "auto",
              //   playbackRates: [],
              //   poster:this_.PageData.image==''?'@/assets/video_bg.gif':this_.PageData.image,
              //   // autoplay:true,
              //   bigPlayButton:true,
              //   licenseUrl: 'license/url',
              // })

            },2000)
            

             

            // 播放

            

          }
          this_.loading = false

        });
      },
      ad_Time(){
        var adBox = document.getElementById('adMask');
        var adclose = document.getElementById('adclose');
        var adclose2 = document.getElementById('adclose2');
        
        clearInterval(counter);

        countdown = 5;
        counter = setInterval(function() {
          
          if (countdown > 0) {
            adBox.style.display = 'none';
            adBox.style.display = 'block';
            adclose.innerHTML = 'Close (' + countdown + ')';
            adclose2.innerHTML = 'Close (' + countdown + ')';
          } else {
            clearInterval(counter);
            adBox.style.display = 'none';
          }

          countdown--;

        }, 1000);
      },
      play(l,g){

        this.l = l
        this.g = g

        var this_ = this
        var playItem = this_.getCurrentPlayItem()
        if(!playItem){
          return
        }


        // 视频覆盖广告
        if(this_.PageData.adlist1.length>0){
          let min = 0,max = this_.PageData.adlist1.length - 1,num = 0

          num = Math.floor(Math.random() * (max - min) + min)

          this_.ad_Show.title= this_.PageData.adlist1[num].title
          this_.ad_Show.url= this_.PageData.adlist1[num].url
          this_.ad_Show.image= this_.PageData.adlist1[num].image

          this_.ad_Time()
        }
        // 视频覆盖广告

        // this.player = TCPlayer("videoPlayer",{
        //   sources: [{
        //     src: this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url, 
        //   }],
        //   URL:'',
        //   language: 'ko',
        //   preload: "auto",
        //   playbackRates: [0.5, 1, 1.25, 1.5, 2, 3],
        //   poster:this_.PageData.image==''?'@/assets/video_bg.gif':this_.PageData.image,
        //   autoplay:true,
        //   bigPlayButton:true,
        //   licenseUrl: 'license/url',
        // })

        // this_.player.controlBar.addChild('NewButton1', {}, 2); 
        // this_.player.controlBar.addChild('NewButton2', {}, 3); 
        
        // console.log(this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url)


        // source.src = newUrl; // 更新视频源URL

        player.src([{
          src: playItem.url,
          // type: "application/x-mpegURL",
          type: "application/vnd.apple.mpegurl",
          poster:this_.PageData.image==''?'@/assets/video_bg.gif':this_.PageData.image,
          // type: "video/mp4",
        }])

        this_.loadSubtitle(playItem.srt)



        // const video = this_.$refs.video
        // if (Hls.isSupported()) {
        //   const hls = new Hls()


        //   hls.loadSource(this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url)

        //   // hls.loadSource('https://videos.theboda1.com/hls/693039cf774f514a4d2ef6a6.m3u8')
        //   hls.attachMedia(video)
        //   hls.on(Hls.Events.MANIFEST_PARSED, () => {
        //     // hls.play()
        //     var srt = this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].srt
        //     if(srt!==''){
        //       try {
        //         // console.log(this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)])
        //         //字幕
        //         const track = video.addTextTrack('subtitles', 'Korean', 'ko');
        //         fetch(srt) // 例如 './subtitles.vtt'
        //         .then(response => response.text())
        //         .then(data => {
        //           const lines = data.split('\n'),Str = data
        //           var timeS,timeE,num = 1,tempLine = '',tempArr
                  
        //           lines.forEach(line => {

        //             if(line==num){
        //               // console.log(num)
        //               tempLine = ''
        //               num ++
        //             }else{
        //               if(line.trim()!==''){
        //                 tempLine += line + '\n'
        //               }
        //             }
        //             if(line.trim()==''){

        //               tempLine = tempLine.replace(/^\s+|\s+$/g,'')
        //               tempArr = tempLine.split('\n')
                      
        //               if(tempArr.length>=2){

        //                 timeS = this_.parseTime(tempArr[0],0)
        //                 timeE = this_.parseTime(tempArr[0],1)
        //                 tempArr.shift()
                        
                        
        //                 track.addCue(new VTTCue(timeS, timeE, tempArr.join('\n')))

        //               }

        //               tempLine = ''
        //             }
        //           });

        //           track.mode = 'showing'; // 显示字幕轨道
        //         });
        //       } catch (error) {
                
        //       }
        //     }
        //   })
        //   // this.$message.error('0')
        // }else if (video.canPlayType('application/vnd.apple.mpegURL')) {

        //   // video.src = 'https://videos.theboda1.com/hls/693039cf774f514a4d2ef6a6.m3u8';
        //   video.src = this_.PageData['play'+this_.l][(this_.PageData['play'+this_.l].length-this_.g)].url
        //   video.addEventListener('loadedmetadata', () => {
        //     video.play();
        //   });
        //   // this.$message.error('1')
        // }

        var element = document.getElementById('detailtop');
          element.scrollIntoView({ behavior: "smooth" ,block: 'start'});
      },
      getVideoElement(){
        try {
          if(player&&player.tech){
            var tech = player.tech()
            var techEl = tech&&tech.el?tech.el():null
            if(techEl&&techEl.tagName&&techEl.tagName.toLowerCase()==='video'){
              return techEl
            }
            if(techEl&&techEl.querySelector){
              var techVideo = techEl.querySelector('video')
              if(techVideo){
                return techVideo
              }
            }
          }
        } catch (error) {

        }

        var video = document.getElementById('videoPlayer')
        if(video&&video.tagName&&video.tagName.toLowerCase()==='video'){
          return video
        }
        if(video&&video.querySelector){
          return video.querySelector('video')
        }
        return document.querySelector('#video_div video')
      },
      clearSubtitle(){
        var track = this.subtitleTrack
        if(this.subtitleTimer){
          clearInterval(this.subtitleTimer)
          this.subtitleTimer = null
        }

        if(track){
          track.mode = 'disabled'
          try {
            while(track.cues&&track.cues.length>0){
              track.removeCue(track.cues[0])
            }
          } catch (error) {

          }
        }
        this.subtitleTrack = null
        this.subtitleTrackUrl = ''
        this.currentSubtitle = ''
        this.subtitleCues = []
      },
      loadSubtitle(srt){
        this.subtitleRequestId += 1
        var requestId = this.subtitleRequestId
        this.clearSubtitle()

        if(!srt||String(srt).trim()===''){
          return
        }
        srt = String(srt).trim()

        var video = this.getVideoElement()
        if(!video){
          return
        }

        var this_ = this
        fetch(srt)
        .then(function(response) {
          return response.text()
        })
        .then(function(data) {
          if(requestId!==this_.subtitleRequestId){
            return
          }

          var cues = this_.parseSrtCues(data)
          this_.subtitleCues = cues
          this_.startSubtitleTimer()

          var Cue = window.VTTCue||window.TextTrackCue
          if(!Cue || !video.addTextTrack){
            return
          }

          var track = video.addTextTrack('subtitles', 'Korean', 'ko')
          cues.forEach(function(item) {
            try {
              track.addCue(new Cue(item.start, item.end, item.text))
            } catch (error) {

            }
          })
          this_.subtitleTrack = track
          this_.subtitleTrackUrl = srt
          track.mode = 'showing'
        })
        .catch(function() {

        })
      },
      startSubtitleTimer(){
        var this_ = this
        if(this.subtitleTimer){
          clearInterval(this.subtitleTimer)
        }
        this.subtitleTimer = setInterval(function() {
          var video = this_.getVideoElement()
          if(!video||!this_.subtitleCues||this_.subtitleCues.length===0){
            this_.currentSubtitle = ''
            return
          }

          var currentTime = video.currentTime || 0
          var activeCue = this_.subtitleCues.find(function(item) {
            return currentTime >= item.start && currentTime <= item.end
          })
          this_.currentSubtitle = activeCue ? activeCue.text : ''
        }, 200)
      },
      getCurrentPlayItem(){
        var list = this.PageData['play'+this.l] || []
        if(list.length===0){
          return null
        }
        var index = list.length - this.g
        if(index < 0){
          index = 0
        }
        if(index >= list.length){
          index = list.length - 1
        }
        return list[index]
      },
      parseSrtCues(data){
        var blocks = data.replace(/^﻿/, '').replace(/\r/g, '').split(/\n{2,}/)
        var cues = []

        blocks.forEach(function(block) {
          block = block.replace(/^\s+|\s+$/g, '')
          if(block===''){
            return
          }

          var lines = block.split('\n')
          var timeIndex = lines.findIndex(function(line) {
            return line.indexOf('-->')>-1
          })

          if(timeIndex>-1){
            var text = lines.slice(timeIndex+1).join('\n').replace(/^\s+|\s+$/g, '')
            if(text!==''){
              cues.push({
                start: this.parseTime(lines[timeIndex], 0),
                end: this.parseTime(lines[timeIndex], 1),
                text: text
              })
            }
          }
        }, this)

        return cues
      },
      parseTime(line,key) {
          var time = line.split('-->')[key]
          if(!time){
            return 0
          }
          var timeParts = time.trim().split(/\s+/)[0].replace(',', '.').split(':')
          var second = parseFloat(timeParts.pop())||0
          var minute = parseInt(timeParts.pop()||0, 10)||0
          var hour = parseInt(timeParts.pop()||0, 10)||0
          return hour * 3600 + minute * 60 + second
      },
      previewSubtitleText(text){
        if(!text){
          return ''
        }
        return String(text).replace(/\n/g, ' ')
      },
    },
    beforeUnmount() {
      this.clearSubtitle()
      clearInterval(this.subtitleTimer)
      this.subtitleTimer = null
    }
  }
</script>
  <style>
  .playList .item {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    padding: 3px 9px;
    /* background-color:rgb(43, 165, 69); */
    background-color: rgb(43, 43, 43);
    color: #818181;
    clip-path: polygon(0px 0, 100% 0, 100% 6px, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%, 0 calc(100% - 6px), 0 6px);
  }

  .playList .item-select {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    padding: 3px 9px;
    background-color: rgba(145, 145, 145, 0.5);
    color: #fff;
    clip-path: polygon(6px 0, 100% 0, 100% 6px, 100% calc(100% - 0px), calc(100% - 6px) 100%, 0 100%, 0 calc(100% - 6px), 0 6px);
  }

  .video_info {
    font-size: 15px;
    margin: 8px 0;
    font-weight: bold;
  }
  .video_info span {
    font-size: 12px;
    font-weight: normal;
  }

  .video-box {
    /* width: 100%; */
    margin: 0 auto;
    position: relative;
  }
  .ad-mask {
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    /* opacity: 0.8; */
    z-index: 88;
  }
  .subtitle-box {
    position: absolute;
    left: 5%;
    right: 5%;
    bottom: 48px;
    z-index: 80;
    color: #fff;
    font-size: 24px;
    font-family: initial;
    font-weight: bold;
    line-height: 1.45;
    text-align: center;
    white-space: pre-line;
    text-shadow: 0 2px 3px #000, 0 0 6px #000;
    pointer-events: none;
  }
  .ad-mask img{
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
  }
  .ad-close {
    position: absolute;
    font-size: 15px;
    font-weight: bold;
    border-radius: 0 0 0 10px ;
    padding: 5px 10px;
    color: #fff;
    background-color: #f00;
    top: 0;
    right: 0;
    opacity: 0.8;
    z-index: 99;
  }
  .ad-close2 {
    position: absolute;
    font-size: 15px;
    font-weight: bold;
    border-radius: 0 10px 0 0;
    padding: 5px 10px;
    color: #fff;
    background-color: #f00;
    bottom: 0;
    left: 0;
    opacity: 0.8;
    z-index: 99;
  }
  </style>
  